import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  createReasonLeave,
  getReasonLeaveById,
  getReasonLeaveList,
  updateReasonLeaveById,
  deleteReasonLeaveById,
} from "./queries";

const ReasonLeaveContext = createContext({});

export const useReasonLeaveContext = () => useContext(ReasonLeaveContext);

export const ReasonLeaveProvider = ({ ...props }) => {
  const [reasonLeaveList, setReasonLeaveList] = useState([]);
  const [reasonLeavePerId, setReasonLeavePerId] = useState({});

  const reasonLeaveListGetter = useCallback(async () => {
    try {
      if (reasonLeaveList.length === 0) {
        setReasonLeaveList(await getReasonLeaveList());
      }
    } catch (e) {
      console.error("reasonLeaveListGetter", e);
      throw e;
    }
  }, [reasonLeaveList]);

  const reasonLeaveByIdGetter = useCallback(
    async (id) => {
      try {
        setReasonLeavePerId(await getReasonLeaveById(id));
      } catch (e) {
        console.error("reasonLeaveByIdGetter", e);
        throw e;
      }
    },
    [setReasonLeavePerId]
  );

  const reasonLeaveUpdateById = useCallback(async (id, data) => {
    try {
      const updatedReasonLeave = await updateReasonLeaveById(id, data);
      setReasonLeaveList((old) =>
        old.map((elm) =>
          elm.id === updatedReasonLeave.id ? updatedReasonLeave : elm
        )
      );
      setReasonLeavePerId(updatedReasonLeave);
    } catch (e) {
      console.error("reasonLeaveUpdateById", e);
      throw e;
    }
  }, []);

  const reasonLeaveCreate = useCallback(async (data) => {
    try {
      const reasonLeave = await createReasonLeave(data);
      setReasonLeaveList((old) => [...old, reasonLeave]);
    } catch (e) {
      console.error("reasonLeaveCreate", e);
      throw e;
    }
  }, []);

  const reasonLeaveDeleteById = useCallback(
    async (id) => {
      try {
        await deleteReasonLeaveById(id);
        setReasonLeaveList((old) => old.filter((row) => row.id !== id));
      } catch (e) {
        console.error("reasonLeaveDeleteById", e);
        throw e;
      }
    },
    [setReasonLeaveList]
  );

  const values = useMemo(
    () => ({
      reasonLeaveCreate,
      reasonLeaveListGetter,
      reasonLeaveByIdGetter,
      reasonLeaveUpdateById,
      reasonLeaveDeleteById,
      reasonLeaveList,
      reasonLeavePerId,
      setReasonLeavePerId,
    }),
    [
      reasonLeaveCreate,
      reasonLeaveListGetter,
      reasonLeaveByIdGetter,
      reasonLeaveUpdateById,
      reasonLeaveDeleteById,
      reasonLeaveList,
      reasonLeavePerId,
      setReasonLeavePerId,
    ]
  );
  return <ReasonLeaveContext.Provider value={values} {...props} />;
};
